export const getObjectProperty = (object, keyPath) => {
  if (!Array.isArray(keyPath)) {
    keyPath = [keyPath];
  }
  return keyPath.reduce((baseObj, key) => baseObj && baseObj[key], object);
};
export const setObjectKeyValue = (obj, keys, value) => {
  var _keys;
  if (!Array.isArray(keys)) {
    keys = [keys];
  }
  let current = obj;
  (_keys = keys) === null || _keys === void 0 || _keys.forEach((key, index) => {
    var _keys2;
    if (index === ((_keys2 = keys) === null || _keys2 === void 0 ? void 0 : _keys2.length) - 1) {
      if (Array.isArray(current[key]) && Array.isArray(value)) {
        // Merge the arrays
        current[key] = [...current[key], ...value];
      } else if (current[key] && typeof current[key] === 'object' && typeof value === 'object') {
        // Merge objects
        current[key] = {
          ...current[key],
          ...value
        };
      } else {
        // Simply set the value if not merging with an array or object
        current[key] = value;
      }
    } else {
      if (!current[key]) {
        current[key] = {};
      }
      current = current[key];
    }
  });
  return obj;
};
export const getObjectParentProperty = (obj, key, prevKey = '') => {
  for (const prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      if (prop === key) {
        return prevKey;
      }
      if (obj[prop] && typeof obj[prop] === 'object') {
        const result = getObjectParentProperty(obj[prop], key, prop);
        if (result) {
          return result;
        }
      }
    }
  }
  return null;
};
export const deepMerge = (target = {}, source) => {
  for (const key in source) {
    if (source.hasOwnProperty(key)) {
      if (typeof target[key] === 'object' && typeof source[key] === 'object') {
        deepMerge(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    }
  }
  return target;
};
//# sourceMappingURL=utils.js.map